import { render, staticRenderFns } from "./ClassDetails.vue?vue&type=template&id=60bac828&"
import script from "./ClassDetails.vue?vue&type=script&lang=js&"
export * from "./ClassDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports